import { Box, makeStyles, TextField, Typography } from "@material-ui/core";
import clsx from "clsx";
import InfoIcon from "src/components/Icon/InfoIcon";
import { THEME_MODE } from "src/config/constants";

const useStyle = makeStyles((theme) => ({
  label: {
    color: theme.palette.text.secondary,
    fontSize: "16px",
    wordWrap: "break-word",
  },
  input: {
    borderRadius: "4px",
    border: `1px solid ${theme.palette.type === THEME_MODE.DARK ? "#263343" : "#D7DFEC"}`,
    backgroundColor: theme.palette.type === THEME_MODE.DARK ? "transparent" : "#EDF3FF",
  },
}));

export default function StrategyNumberInput({ title, info, InputProps, classes, ...props }) {
  const cls = useStyle();

  return (
    <Box className={classes?.root}>
      <Box className={classes?.box}>
        <Typography className={clsx(cls.label, classes?.title)}>
          {title} <InfoIcon title={info} />
        </Typography>
      </Box>
      {InputProps?.StartAdornment && InputProps.StartAdornment}
      <TextField type="number" fullWidth size="small" variant="outlined" {...props} />
    </Box>
  );
}
